import React from 'react'

function GotabitIcon() {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ margin: '4px 0 3px 0' }}
    >
      <g clipPath="url(#clip0_32267_3431)">
        <path
          d="M720 0H304C136.105 0 0 136.105 0 304V720C0 887.895 136.105 1024 304 1024H720C887.895 1024 1024 887.895 1024 720V304C1024 136.105 887.895 0 720 0Z"
          fill="url(#paint0_linear_32267_3431)"
        />
        <g style={{ mixBlendMode: 'soft-light' }}>
          <path
            d="M720 2H304C137.21 2 2 137.21 2 304V720C2 886.79 137.21 1022 304 1022H720C886.79 1022 1022 886.79 1022 720V304C1022 137.21 886.79 2 720 2Z"
            stroke="black"
            strokeOpacity="0.12"
            strokeWidth="2"
          />
        </g>
        <g style={{ mixBlendMode: 'soft-light' }}>
          <path d="M976 48H48V976H976V48Z" fill="url(#pattern0)" />
        </g>
        <g
          style={{ mixBlendMode: 'soft-light' }}
          filter="url(#filter0_d_32267_3431)"
        >
          <path
            d="M720 48H304C162.615 48 48 162.615 48 304V720C48 861.385 162.615 976 304 976H720C861.385 976 976 861.385 976 720V304C976 162.615 861.385 48 720 48Z"
            fill="white"
            fillOpacity="0.5"
          />
        </g>
        <g filter="url(#filter1_iii_32267_3431)">
          <path
            d="M389.542 216.358C428.366 200.276 469.976 192 512 192H516C549.604 192 566.404 192 579.24 198.54C590.53 204.292 599.708 213.47 605.46 224.76C612 237.596 612 254.396 612 288V296C612 329.604 612 346.404 605.46 359.24C599.708 370.53 590.53 379.708 579.24 385.46C566.404 392 549.604 392 516 392H512C496.242 392 480.638 395.104 466.078 401.136C451.52 407.166 438.29 416.004 427.148 427.148C416.006 438.29 407.166 451.52 401.136 466.078C395.104 480.638 392.002 496.242 392.002 512C392.002 527.758 395.104 543.362 401.136 557.922C407.166 572.48 416.006 585.71 427.148 596.852C438.29 607.994 451.52 616.834 466.078 622.864C480.638 628.894 496.242 631.998 512 631.998H512.52C578.554 631.718 632 578.1 632 512C632 456.772 676.772 412 732 412C787.228 412 832 456.772 832 512C832 567.228 787.228 612 732 612C665.726 612 612 665.726 612 732V736C612 769.604 612 786.404 605.46 799.24C599.708 810.53 590.53 819.708 579.24 825.46C566.404 832 549.604 832 516 832H512C469.978 832 428.366 823.722 389.542 807.642C350.718 791.56 315.44 767.988 285.726 738.274C256.012 708.56 232.44 673.282 216.358 634.458C200.278 595.634 192 554.022 192 512C192 469.976 200.278 428.366 216.358 389.542C232.44 350.718 256.012 315.44 285.726 285.726C315.44 256.012 350.718 232.44 389.542 216.358Z"
            fill="url(#paint1_linear_32267_3431)"
          />
          <path
            d="M389.542 216.358C428.366 200.276 469.976 192 512 192H516C549.604 192 566.404 192 579.24 198.54C590.53 204.292 599.708 213.47 605.46 224.76C612 237.596 612 254.396 612 288V296C612 329.604 612 346.404 605.46 359.24C599.708 370.53 590.53 379.708 579.24 385.46C566.404 392 549.604 392 516 392H512C496.242 392 480.638 395.104 466.078 401.136C451.52 407.166 438.29 416.004 427.148 427.148C416.006 438.29 407.166 451.52 401.136 466.078C395.104 480.638 392.002 496.242 392.002 512C392.002 527.758 395.104 543.362 401.136 557.922C407.166 572.48 416.006 585.71 427.148 596.852C438.29 607.994 451.52 616.834 466.078 622.864C480.638 628.894 496.242 631.998 512 631.998H512.52C578.554 631.718 632 578.1 632 512C632 456.772 676.772 412 732 412C787.228 412 832 456.772 832 512C832 567.228 787.228 612 732 612C665.726 612 612 665.726 612 732V736C612 769.604 612 786.404 605.46 799.24C599.708 810.53 590.53 819.708 579.24 825.46C566.404 832 549.604 832 516 832H512C469.978 832 428.366 823.722 389.542 807.642C350.718 791.56 315.44 767.988 285.726 738.274C256.012 708.56 232.44 673.282 216.358 634.458C200.278 595.634 192 554.022 192 512C192 469.976 200.278 428.366 216.358 389.542C232.44 350.718 256.012 315.44 285.726 285.726C315.44 256.012 350.718 232.44 389.542 216.358Z"
            fill="url(#paint2_radial_32267_3431)"
          />
          <path
            d="M512.52 632.976H512.524C579.096 632.694 632.976 578.638 632.976 512C632.976 457.31 677.31 412.976 732 412.976C786.69 412.976 831.024 457.31 831.024 512C831.024 566.69 786.69 611.024 732 611.024C665.186 611.024 611.024 665.186 611.024 732V736C611.024 752.818 611.022 765.372 610.21 775.328C609.396 785.274 607.778 792.54 604.59 798.796C598.932 809.902 589.902 818.932 578.796 824.59C572.54 827.778 565.274 829.396 555.328 830.21C545.372 831.022 532.818 831.024 516 831.024H512C470.106 831.024 428.62 822.772 389.916 806.74C351.21 790.706 316.04 767.208 286.416 737.584C256.792 707.96 233.294 672.79 217.26 634.084C201.228 595.38 192.977 553.894 192.977 512C192.977 470.106 201.228 428.62 217.26 389.914C233.294 351.21 256.792 316.04 286.416 286.416C316.04 256.792 351.21 233.294 389.916 217.26C428.62 201.228 470.106 192.977 512 192.977H516C532.818 192.977 545.372 192.977 555.328 193.791C565.274 194.603 572.54 196.222 578.796 199.41C589.902 205.068 598.932 214.098 604.59 225.204C607.778 231.46 609.396 238.726 610.21 248.672C611.022 258.628 611.024 271.182 611.024 288V296C611.024 312.818 611.022 325.372 610.21 335.328C609.396 345.274 607.778 352.54 604.59 358.796C598.932 369.902 589.902 378.932 578.796 384.59C572.54 387.778 565.274 389.396 555.328 390.21C545.372 391.022 532.818 391.024 516 391.024H512C496.114 391.024 480.382 394.154 465.704 400.234C451.028 406.312 437.692 415.224 426.458 426.458C415.224 437.69 406.312 451.028 400.234 465.704C394.154 480.382 391.024 496.114 391.024 512C391.024 527.886 394.154 543.618 400.234 558.296C406.312 572.972 415.224 586.308 426.458 597.542C437.692 608.776 451.028 617.688 465.704 623.766C480.382 629.846 496.114 632.976 512 632.976H512.52Z"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="0.976563"
          />
        </g>
      </g>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_32267_3431" transform="scale(0.00215517)" />
        </pattern>
        <filter
          id="filter0_d_32267_3431"
          x="24"
          y="24"
          width="976"
          height="976"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_32267_3431"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_32267_3431"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_iii_32267_3431"
          x="175.333"
          y="175.333"
          width="673.333"
          height="673.333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="16.6667" dy="16.6667" />
          <feGaussianBlur stdDeviation="16.6667" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_32267_3431"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-16.6667" dy="-16.6667" />
          <feGaussianBlur stdDeviation="16.6667" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_32267_3431"
            result="effect2_innerShadow_32267_3431"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="16.6667" dy="-16.6667" />
          <feGaussianBlur stdDeviation="16.6667" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.5875 0 0 0 0 0.5875 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_32267_3431"
            result="effect3_innerShadow_32267_3431"
          />
        </filter>
        <linearGradient
          id="paint0_linear_32267_3431"
          x1="512"
          y1="0"
          x2="512"
          y2="1024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4040E0" />
          <stop offset="1" stopColor="#1C1C88" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_32267_3431"
          x1="832.312"
          y1="191.687"
          x2="191.687"
          y2="832.312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6E6F8" />
          <stop offset="1" stopColor="#C8C8EE" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_32267_3431"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(832.312 191.687) rotate(135) scale(905.98)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_32267_3431">
          <rect width="1024" height="1024" fill="white" />
        </clipPath>
        <image
          id="image0_32267_3431"
          width="464"
          height="464"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  )
}

export default GotabitIcon
